import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Film } from "lucide-react";

const HERO = "https://static.prod-images.emergentagent.com/jobs/abd4f8f5-ed5f-494d-9745-ce8734069e02/images/fabd9cf027eb574349b34f63d3550bc91d596063034da3e60412acf978dfb12a.jpeg";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await register(name, email, password, phone);
      toast.success("Doğrulama kodu e-postanıza gönderildi");
      navigate("/verify", { state: { email: data.email || email } });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-16 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
          <p className="text-sm uppercase tracking-[0.3em] text-gold mb-3">Kayıt</p>
          <h1 className="font-serif text-4xl mb-8">Hesap oluştur</h1>
          <div className="space-y-5">
            <div>
              <Label className="text-white/70">Ad Soyad</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} required
                data-testid="register-name-input"
                className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold h-11"
                placeholder="Adınız Soyadınız" />
            </div>
            <div>
              <Label className="text-white/70">E-posta</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="register-email-input"
                className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold h-11"
                placeholder="ornek@eposta.com" />
            </div>
            <div>
              <Label className="text-white/70">WhatsApp / Telefon <span className="text-white/30 text-xs">(opsiyonel)</span></Label>
              <Input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
                data-testid="register-phone-input"
                className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold h-11"
                placeholder="+90 532 123 45 67" />
            </div>
            <div>
              <Label className="text-white/70">Şifre</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
                data-testid="register-password-input"
                className="mt-2 bg-[#121212] border-white/10 focus:border-gold focus-visible:ring-gold h-11"
                placeholder="En az 6 karakter" />
            </div>
            <Button type="submit" disabled={loading} data-testid="register-submit-button"
              className="w-full bg-gold text-black hover:bg-gold-light h-11 rounded-md">
              {loading ? "Oluşturuluyor…" : "Kayıt Ol"}
            </Button>
          </div>
          <p className="text-sm text-white/50 mt-6">
            Zaten hesabın var mı?{" "}
            <Link to="/login" className="text-gold hover:underline" data-testid="go-login-link">Giriş yap</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/30" />
        <div className="absolute bottom-12 left-12 max-w-sm">
          <Film className="w-8 h-8 text-gold mb-4" />
          <h2 className="font-serif text-4xl leading-tight">Hikâyen burada başlıyor.</h2>
          <p className="text-white/60 mt-3">Ücretsiz kaydol, ilk fikrini yaz.</p>
        </div>
      </div>
    </div>
  );
}
